import { render, staticRenderFns } from "./WorkflowList.vue?vue&type=template&id=2bd3c40d&lang=html"
import script from "./WorkflowList.vue?vue&type=script&lang=js"
export * from "./WorkflowList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports